// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import { WorkbookListItemFragmentFragmentDoc } from "../../WorkbookListTable/gql/Fragment.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type WorkbooksForServerQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
}>;

export type WorkbooksForServerQuery = {
  __typename?: "GraphqlQuery";
  getWorkbooks: Array<{
    __typename?: "Workbook";
    id: string;
    name: string;
    description?: string | null;
    createdAt: number;
    lastActivityAt: number;
    variantsCount: number;
    draft: boolean;
    channel?: string | null;
    user?: { __typename?: "User"; id: string; fullname?: string | null } | null;
    server: {
      __typename?: "Server";
      id: string;
      humanId: string;
      name: string;
    };
    database: { __typename?: "Database"; id: string; datname?: string | null };
  }>;
};

export const WorkbooksForServerDocument = gql`
  query WorkbooksForServer($serverId: ID!) {
    getWorkbooks(serverId: $serverId) {
      ...WorkbookListItemFragment
    }
  }
  ${WorkbookListItemFragmentFragmentDoc}
`;

/**
 * __useWorkbooksForServerQuery__
 *
 * To run a query within a React component, call `useWorkbooksForServerQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbooksForServerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbooksForServerQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *   },
 * });
 */
export function useWorkbooksForServerQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkbooksForServerQuery,
    WorkbooksForServerQueryVariables
  > &
    (
      | { variables: WorkbooksForServerQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WorkbooksForServerQuery,
    WorkbooksForServerQueryVariables
  >(WorkbooksForServerDocument, options);
}
export function useWorkbooksForServerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkbooksForServerQuery,
    WorkbooksForServerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkbooksForServerQuery,
    WorkbooksForServerQueryVariables
  >(WorkbooksForServerDocument, options);
}
// @ts-ignore
export function useWorkbooksForServerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkbooksForServerQuery,
    WorkbooksForServerQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkbooksForServerQuery,
  WorkbooksForServerQueryVariables
>;
export function useWorkbooksForServerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkbooksForServerQuery,
        WorkbooksForServerQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkbooksForServerQuery | undefined,
  WorkbooksForServerQueryVariables
>;
export function useWorkbooksForServerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkbooksForServerQuery,
        WorkbooksForServerQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WorkbooksForServerQuery,
    WorkbooksForServerQueryVariables
  >(WorkbooksForServerDocument, options);
}
export type WorkbooksForServerQueryHookResult = ReturnType<
  typeof useWorkbooksForServerQuery
>;
export type WorkbooksForServerLazyQueryHookResult = ReturnType<
  typeof useWorkbooksForServerLazyQuery
>;
export type WorkbooksForServerSuspenseQueryHookResult = ReturnType<
  typeof useWorkbooksForServerSuspenseQuery
>;
export type WorkbooksForServerQueryResult = Apollo.QueryResult<
  WorkbooksForServerQuery,
  WorkbooksForServerQueryVariables
>;
